import cody from "../../images/teampics/Cody.jpg";
import hank from "../../images/teampics/Hank.jpg";
import jifft2 from "../../images/teampics/Jifft2.jpg";
// import julius from "../../images/teampics/Julius.jpg";
import julius2 from "../../images/teampics/Julius2.jpg";
import loki from "../../images/teampics/Loki.jpg";
import lola from "../../images/teampics/Lola.jpg";
import maggie from "../../images/teampics/Maggie.jpg";
import mrfurrley from "../../images/teampics/Mr Furrley.JPG";
import ori from "../../images/teampics/Ori.jpg";
import rufus from "../../images/teampics/Rufus.jpg";
import umka from "../../images/teampics/Umka.jpg";
import winnie from "../../images/teampics/Winnie.jpg";


// Tools:
// https://bulkresizephotos.com/en
// https://heictojpg.com/
// 480 x 640 Dimensions

const imageData = [
  {
    original: winnie,
    thumbnail: winnie,
    description: "Winnie"
  },
  {
    original: cody,
    thumbnail: cody,
    description: "Cody"
  },
  {
    original: hank,
    thumbnail: hank,
    description: "Hank"
  },
  {
    original: jifft2,
    thumbnail: jifft2,
    description: "Jiffy"
  },
  // {
  //   original: julius,
  //   thumbnail: julius,
  //   description: "Julius"
  // },
  {
    original: julius2,
    thumbnail: julius2,
    description: "Julius"
  },
  {
    original: loki,
    thumbnail: loki,
    description: "Loki"
  },
  {
    original: lola,
    thumbnail: lola,
    description: "Lola"
  },
  {
    original: maggie,
    thumbnail: maggie,
    description: "Maggie"
  },
  {
    original: mrfurrley,
    thumbnail: mrfurrley,
    description: "Mr Furrley"
  },
  {
    original: ori,
    thumbnail: ori,
    description: "Ori"
  },
  {
    original: rufus,
    thumbnail: rufus,
    description: "Rufus"
  },
  {
    original: umka,
    thumbnail: umka,
    description: "Umka"
  }
];

export default imageData;
